module.exports = __webpack_public_path__ + "Server-Default.Kubernetes.74ee5bd88981a6a9c3cee6bf260919c9.hashedasset.svg";